import React, { useState, useRef } from "react";

import axios from "axios"

const UploadSealSignPopup = ({ isOpen, onClose, currentDetailsForImageUpload }) => {
    const [preview, setPreview] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);

    if (!isOpen) return null;

    const handleFile = (file) => {
        if (!file) return;
        if (!file.type.startsWith("image/")) {
            alert("Please select a valid image file.");
            return;
        }
        setSelectedFile(file);
        setPreview(URL.createObjectURL(file));
    };

    const handleFileChange = (e) => handleFile(e.target.files[0]);

    const handleRemove = () => {
        setPreview(null);
        setSelectedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });

    const handleSubmit = async () => {
        if (!selectedFile) {
            alert("Please select an image first.");
            return;
        }

        let resultOfBAse64Conversion = await toBase64(selectedFile);

        try {
            const companyCode = localStorage.getItem("companyCode") || "-";

            const apiPaths = JSON.parse(localStorage.getItem("apiPaths")) || [];



            // confirm what to pass in code if username is blank what to pass

            if (currentDetailsForImageUpload?.userObject?.loginame?.trim() === "") {
                alert("Username missing, cannot upload")
                return
            }
            const payload = [
                {
                    CmpCode: companyCode,
                    mode: "ENTRY",
                    category: currentDetailsForImageUpload.image_doc_type,
                    code: currentDetailsForImageUpload.userObject.loginame ? currentDetailsForImageUpload.userObject.loginame : "-",
                    imgbase64: resultOfBAse64Conversion,
                }
            ];

            let serializedData = JSON.stringify(payload);

            console.log("serializedData ", serializedData, currentDetailsForImageUpload.userObject)




            const response = await axios.post(
                `${apiPaths[0].API_CONFIG}/api/CRMimagebase64`,
                serializedData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            console.log("Image Upload Success:", response.data);

            if (response.data.result?.trim()?.toUpperCase() === "SAVED") {
                alert("Success")
                handleRemove();
                onClose();
            } else {
                alert("Failed to save")
            }



        } catch (error) {
            console.error("Image Upload Failed:", error);
            alert("Error while uploading")

        }





    };

    const handleClose = () => {
        handleRemove();  // clears preview + selectedFile
        onClose();
    };
    

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            onClick={handleOverlayClick}
        >
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 p-6">

                {/* Header */}
                <div className="flex items-center justify-between mb-5">
                    <h2 className="text-lg font-semibold text-gray-800">Upload {currentDetailsForImageUpload.image_doc_type}</h2>
                    <button
                        onClick={handleClose}
                        className="text-gray-400 hover:text-gray-600 text-xl font-bold"
                    >
                        ✕
                    </button>
                </div>

                {/* Preview or Pick button */}
                {preview ? (
                    <div className="relative rounded-xl overflow-hidden border border-gray-200">
                        <img
                            src={preview}
                            alt="Preview"
                            className="w-full h-56 object-contain bg-gray-50"
                        />
                        <button
                            onClick={handleRemove}
                            className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white rounded-full w-7 h-7 flex items-center justify-center text-sm font-bold shadow"
                        >
                            ✕
                        </button>
                    </div>
                ) : (
                    <div
                        onClick={() => fileInputRef.current.click()}
                        className="border-2 border-dashed border-gray-300 rounded-xl p-10 flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-colors"
                    >
                        <span className="text-4xl mb-3">🖼️</span>
                        <p className="text-sm font-medium text-gray-700">Click to browse image</p>
                        {/* <p className="text-xs text-gray-400 mt-1">PNG, JPG, JPEG, WEBP</p> */}
                    </div>
                )}

                {/* File name */}
                {selectedFile && (
                    <p className="text-xs text-gray-500 mt-2 text-center truncate">
                        {selectedFile.name} ({(selectedFile.size / 1024).toFixed(1)} KB)
                    </p>
                )}

                {/* Hidden input */}
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={handleFileChange}
                />

                {/* Buttons */}
                <div className="flex gap-3 mt-5">
                    <button
                        onClick={handleClose}
                        className="flex-1 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={!selectedFile}
                        className={`flex-1 py-2 rounded-lg text-sm font-semibold text-white transition-colors
              ${selectedFile
                                ? "bg-blue-600 hover:bg-blue-700"
                                : "bg-blue-300 cursor-not-allowed"
                            }`}
                    >
                        Upload
                    </button>
                </div>

            </div>
        </div>
    );
};

export default UploadSealSignPopup;